import React from 'react';
import { components, MenuListProps } from 'react-select';
import VirtualizedMenuList from '../VirtualizedMenuList/VirtualizedMenuList';
import './SelectAllMenuList.scss';

type SelectAllMenuListProps = MenuListProps & {
    selectProps: MenuListProps['selectProps'] & {
        enableVirtualization?: boolean;
    };
};

const SelectAllMenuList: React.FC<SelectAllMenuListProps> = ({
    selectProps,
    options: menuOptions,
    ...menuListProps
}) => {
    const { value, onChange, enableVirtualization } = selectProps;
    const allOptions = menuOptions || [];
    const currentValue = Array.isArray(value) ? value : [];
    const allSelected =
        allOptions.length > 0 && currentValue.length === allOptions.length;

    const handleToggleSelectAll = (event: React.MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        if (allSelected) {
            onChange([], {
                action: 'clear',
                removedValues: currentValue,
            });
            return;
        }
        onChange(allOptions, {
            action: 'select-option',
            option: allOptions[0],
        });
    };

    const ListComponent = enableVirtualization
        ? VirtualizedMenuList
        : components.MenuList;

    return (
        <div className="custom-dropdown-select-all-menu">
            <button
                type="button"
                className="custom-dropdown-select-all-menu__action"
                onMouseDown={handleToggleSelectAll}
            >
                {allSelected ? 'Deselect All' : 'Select All'}
            </button>
            <ListComponent
                selectProps={selectProps}
                options={menuOptions}
                {...menuListProps}
            />
        </div>
    );
};

export default SelectAllMenuList;
